module.exports = __webpack_public_path__ + "img/water_tank_low.717e9be6.svg";